import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    height: 50,
    '&::-webkit-scrollbar': {
      width: 8
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.primary.main,
      borderRadius: 0
    }
  },
  avatar: {
    margin: '0px 0.25rem',
    cursor: 'pointer'
  },
  selectedUser: {
    outline: `solid 2px ${theme.palette.primary.main}`
  }
}))

export default useStyles
